<template>
	<div>
		<h4 v-if="content.title">{{ content.title }}</h4>
		<button class="btn btn-component" :class="content.settings.size">{{ content.text }}</button>
	</div>
</template>

<script>
export default {
	name: "PostButtonComponent",
	data() {
		return {};
	},
	props: {
		content: {
			required: true,
		},
	},
};
</script>

<style scoped>
.btn-component {
	background-color: var(--main-color);
	border-radius: 8px;
	padding: 10px 20px;
	border: none;
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/PostButtonComponent.vue